export const RenderDecisionSection = ({singleTicketDetails,selectedAnswer,setSelectedAnswer,isUiDisabled,description,setDescription,loadingDetails,ButtonsForUpdateTicket,handleDecisionSubmit,handleBack,handleDecisionCancel}) => {
        return (
          <div>
              <hr style={{ border: "1px solid #ccc", margin: "10px 0" }} /> 
              <div className="approval-container">
                <div className="mb-3">
                  <span className="info-value">Question:</span>
                  <span className="summary-text">{singleTicketDetails.remarks}</span>
                </div>
                <div className="decision-container">
                  {singleTicketDetails?.possibleAnswers?.map((ans) => (
                    <label
                      key={ans}
                      className={`decision-option ${selectedAnswer === ans ? "selected" : ""
                        }`}
                    >
                      <input
                        type="radio"
                        name="decision"
                        value={ans}
                        checked={selectedAnswer === ans}
                        onChange={(e) => setSelectedAnswer(e.target.value)}
                      />
                      <span className="decision-text">{ans}</span>
                    </label>
                  ))}
                </div>                                                                    
              </div>
                <div className={`details-input-container mb-3 ${isUiDisabled ? "disabled-ticket" : ""}`}>
                  <h6 className="fw-semibold">Remarks</h6>
                  <textarea
                    className="form-control"
                    placeholder="Please enter remarks for this ticket..."
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    rows={4}
                    disabled={loadingDetails || isUiDisabled}
                  />
                </div>
                <div className={`d-flex justify-content-end gap-2 mt-2 ${isUiDisabled ? "disabled-ticket" : ""}`}>
                  {ButtonsForUpdateTicket(handleDecisionSubmit,(loadingDetails ? "Submitting..." : "Submit Decision"), 4,!selectedAnswer)}
                  {ButtonsForUpdateTicket(handleDecisionCancel,"Cancel", 4,!selectedAnswer)}
                  {ButtonsForUpdateTicket(handleBack, "Go back to my tickets", 4)}                    
                </div>
          </div>
        );
  };